<script lang="ts">
import { EHeroAspectRatios, ETitleFontSizes } from '../../../config/enums';
import HeroImage from '../../molecules/HeroImage/HeroImage.svelte';
import HeroVideo from '../../molecules/HeroVideo/HeroVideo.svelte';

interface Props {
    content?: string;
    mastheadTextColour?: string;
    image?: HeroImageValue;
    mobileImage?: HeroImageValue;
    link?: string;
    linkText?: string;
    link2?: string;
    linkText2?: string;
    muxId?: string;
    muxIdMobile?: string;
    poster?: string;
    posterMobile?: string;
    subContent?: string;
    inverseButtonColours?: boolean;
    headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    titleSize?: string;
    aspectRatio?: string;
    hideBlock?: boolean;
}

type HeroImageValue = {
    alt?: string;
    src?: string;
    [key: string]: unknown;
};

let {
    content = '',
    mastheadTextColour = '#000',
    image = {},
    mobileImage = {},
    link = '',
    linkText = 'Learn More',
    link2 = '',
    linkText2 = 'Learn More',
    muxId = '',
    muxIdMobile = '',
    poster = '',
    posterMobile = '',
    subContent = '',
    inverseButtonColours = false,
    headingLevel = 'h1',
    titleSize = ETitleFontSizes.H1,
    aspectRatio = EHeroAspectRatios.DEFAULT,
    hideBlock = false,
}: Props = $props();
</script>

{#if !hideBlock}
    <div class="hero">
        {#if muxId}
            <HeroVideo
                {content}
                {mastheadTextColour}
                {muxId}
                {muxIdMobile}
                {link}
                {link2}
                {linkText}
                {linkText2}
                {poster}
                {posterMobile}
                {inverseButtonColours}
                {headingLevel}
                {titleSize}
                {subContent}
            />
        {:else}
            <HeroImage
                {content}
                {mastheadTextColour}
                {image}
                {mobileImage}
                {link}
                {link2}
                {linkText}
                {linkText2}
                {inverseButtonColours}
                {headingLevel}
                {titleSize}
                {subContent}
                {aspectRatio}
            />
        {/if}
    </div>
{/if}

<style lang="scss">
    .hero {
        position: relative;
    }
</style>
